import React from "react";
import { FormFieldError } from "components/shared-ui/form/form-field-error/form-field-error";
import { FormField } from "components/shared-ui/form/form-field/form-field";
import TextInput from "components/shared-ui/input/text-input/text-input";
import styles from "./entity-name-section.module.scss";
import { IIAMUserRequest } from "api/entities/iam-users";
import { IAMEntity, validators } from "utils/validators";
import { IIAMGroupRequest } from "api/entities/iam-groups";
import { IIAMPolicyCreateRequest } from "api/entities/iam-policies";

export type IIAMEntityNameSectionErrors = { name: string };

export interface IIAMEntityNameSectionProps<T> {
  request: T;
  field: keyof T & string;
  type: IAMEntity;
  errors: IIAMEntityNameSectionErrors;
  onChange: (entityUpdate: Partial<T>) => void;
  onError: (errors: Partial<IIAMEntityNameSectionErrors>) => void;
  className?: string;
  disabled?: boolean;
  placeHolder?: string
}

export function IAMEntityNameSection<
  T extends IIAMUserRequest | IIAMGroupRequest | IIAMPolicyCreateRequest
>(props: IIAMEntityNameSectionProps<T>) {
  function handleChange(entityUpdate: Partial<T>) {
    const updatedEntityRequest = { ...props.request, ...entityUpdate };
    props.onChange(updatedEntityRequest);

    props.onError({
      [props.field]: validators.validateIAMEntityName(
        updatedEntityRequest[props.field] as string,
        props.type
      ),
    });
  }

  return (
    <FormField
      testId={`iam-entity-${props.field}-name`}
      label="Name"
      className={props.className}
      visible={true}
    >
      <TextInput
        placeholder={props.placeHolder}
        disabled={props.disabled}
        className={styles.name}
        testId={`iam-${props.field}-name-input`}
        autoFocus={true}
        value={(props.request[props.field] as string) || ""}
        onChange={(name) => handleChange({ [props.field]: name } as Partial<T>)}
      />
      <FormFieldError error={props.errors?.name} />
    </FormField>
  );
}
